import React from 'react';
import Payments from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const StripeRechargeCredit = React.lazy(() => import('./StripeRechargeCredit'));
const RechargeCreditPage = (props) => (
  <Payments>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <StripeRechargeCredit {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </Payments>
);

export default RechargeCreditPage;
